import { uiComponents, uiStates } from '@/tools/viewState';
import { actionTypes, mutationTypes, articleTypes, errorTypes } from '@/types';
import { generateUUID } from '@/tools/helpers';
import { getLangLanguageConent, getLanguageContentWithFallback } from '@/tools/languageValue';
import { setUrlToDataSource } from '@/tools/setUrlToDataSource';
import { SEARCH_SCOPES } from '@/tools/consts';
/**
 * This action open the ui--search with scope Tour. Pass an tourID to
 * show all articles of belonging tour
 * @param {*} store
 * @param { id } exhibitionID
 */
export default function({ rootState, commit, dispatch }, { tourID, options = {} }) {
	const tour = rootState.tour.toursMap[tourID];

	if (!tour) {
		dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.unknownTour) });
		return;
	}
	const exhibition = rootState.dataSourceCFG.exhibitionMap[tour.exhibitionID];

	if (!exhibition) {
		dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.unkownExhibition) });
		return;
	}
	const data = tour.exhibitIDs
		.map(exhibit => exhibit.articleID)
		.map(articleID => exhibition.articleMap[articleID])
		.filter(article => article.type !== articleTypes.articleList && article.type !== 'tour-list')
		.map((article, index) => {
			const languageContent = getLanguageContentWithFallback(article.languageContent);
			languageContent.cover = languageContent.coverImage
				? setUrlToDataSource(`../media-${languageContent.coverImage}/512`, rootState.dataSourceURL)
				: undefined;
			return {
				key: generateUUID(),
				name: article.name,
				class: 'data--' + article.name,
				active: `${rootState.visitedArticleIDs.hasOwnProperty(article.id)}`,
				url: '',
				role: 'link',
				click: () => {
					dispatch(actionTypes.tourJumpToPosition, { position: index + 1 });
				},
				...languageContent,
			};
		}); // eslint-disable-next-line
	//Add Header Entry
	const tourLanguageContent = getLanguageContentWithFallback(tour.languageContent);
	data.unshift({
		name: 'list-header',
		class: 'header--' + tour.id,
		active: 'true',
		url: '',
		title: tourLanguageContent.title,
		description: tourLanguageContent.description,
		cover: tour.coverID
			? setUrlToDataSource(
					`../media-${getLangLanguageConent(tour.coverID.languageContent).source}/512`,
					rootState.dataSourceURL
			  )
			: undefined,
	});
	commit(mutationTypes.searchSetData, {
		scope: SEARCH_SCOPES.tour,
		data,
		searchOptions: {
			keys: ['title', 'description'],
			threshold: 0.3,
			caseSensitive: false,
		},
		options,
	});
	commit(mutationTypes.viewStateSetUiState, {
		id: uiComponents.uiSearchTour,
		uiState: uiStates.maximised,
	});
}
